<template>
  <div class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()"
                class="column is-12 pdr-0">
            <b-input :placeholder="$t('general.button.search')"
                     type="search" icon="magnify" v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      v-if="startArrayRendering"
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="code" slot-scope="props">
        <router-link-blank :to="{ name: 'c.gabed.commande_tlpe',
                                      params: {id: props.row.id}}"
                           class="lien"
                           :message="props.row.code">
        </router-link-blank>
      </div>
      <div slot="declarant" slot-scope="props">
        {{ getNomPrenomCommercial(props.row.commercial) }}
      </div>
      <div slot="annee" slot-scope="props">
        {{ getYear(props.row.dateDevisCommande) }}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getLibelleEtat(props.row.etat)) }}
      </div>
      <div slot="typeDeclaration" slot-scope="props">
        {{ $t(getLibelleTypeDeclaration(props.row.typeDeclaration)) }}
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-liste-commande-tlpe ref="filtreListeCommandeTlpe"
                                  :criteres-recherche="criteresRecherche"
                                  @toggleFiltre="setShowFiltre"
                                  @recherche="makeRechercheFilter">
      </filtre-liste-commande-tlpe>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import genererCritereRecherche
  from '@/services/gabed/commandeTlpe/genererCritereRechercheCommanndeTlpe';
import TableItemsInView from '@/components/general/TableItemsInView';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import formatDate from '@/services/general/formatIsoDate';
import * as devisConf from '@/configuration/devisConf';
import { LISTE_TYPE_DECLARATION } from '@/configuration/gabed/tlpe/tlpeConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import filtreListeCommandeTlpe
  from '@/components/gabed/collectivite/detail/filtreListeCommandeTlpeParCollectivite';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_INFO_COMMANDE_TLPE } from '@/configuration/general/referenceTableConf';

const Societe = createNamespacedHelpers('societe');
const CommandeTlpe = createNamespacedHelpers('commandeTlpe');

export default {
  name: 'InfoCommandeTlpe',
  props: {
    collectivite: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showFiltre: false,
      criteresRecherche: genererCritereRecherche(),
      referenceTable: REFERENCE_TABLE_INFO_COMMANDE_TLPE,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
    };
  },
  components: {
    TableItemsInView,
    routerLinkBlank,
    filtreListeCommandeTlpe,
    parametrageTable,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...CommandeTlpe.mapGetters({
      total: 'total',
      commandesTlpe: 'items',
    }),
    nombreCritere() {
      const banCritere = ['auto'];
      return calculNombreCritere(this.criteresRecherche, banCritere);
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('detailCollectivite.commandeTlpe.tab.code'),
          annee: this.$i18n.t('detailCollectivite.commandeTlpe.tab.annee'),
          codeDossier: this.$i18n.t('detailCollectivite.commandeTlpe.tab.codeDossier'),
          declarant: this.$i18n.t('detailCollectivite.commandeTlpe.tab.declarant'),
          etat: this.$i18n.t('detailCollectivite.commandeTlpe.tab.etat'),
          typeDeclaration: this.$i18n.t('detailCollectivite.commandeTlpe.tab.typeDeclaration'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.tiersId = [this.collectivite.id];
          if (data.query.annee) {
            data.query.dates = {
              dateDebut: formatDate(moment(data.query.annee, 'GGGG').startOf('year')),
              dateFin: formatDate(moment(data.query.annee, 'GGGG').endOf('year')),
            };
            delete data.query.annee;
          }
          if (!data.query.etat || data.query.etat.length === 0) {
            data.query.etat = [
              devisConf.ETAT_ENREGISTRE,
              devisConf.ETAT_FACTURE,
              devisConf.ETAT_FACTURE_PARTIELLEMENT,
            ];
          }
          data.query.societeId = this.societeActiveId;
          return this.loadCommandeTlpe(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.commandesTlpe,
            count: this.total,
          };
        }),
        sortable: ['code', 'codeDossier'],
      };
    },
    columns() {
      return ['code', 'annee', 'declarant', 'etat', 'typeDeclaration', 'codeDossier'];
    },
  },
  methods: {
    ...CommandeTlpe.mapActions({
      loadCommandeTlpe: 'loadCommandeTlpe',
    }),
    getYear(date) {
      if (!date) return null;
      return moment(date).year();
    },
    getLibelleTypeDeclaration(codeTypeDeclaration) {
      const typeDeclarationFind = LISTE_TYPE_DECLARATION.find((t) => {
        return t.code === codeTypeDeclaration;
      });
      return typeDeclarationFind ? typeDeclarationFind.libelle : '';
    },
    getLibelleEtat(codeEtat) {
      const etatFind = devisConf.DEVIS_COMMANDE_ETAT.find((e) => {
        return e.code === codeEtat;
      });
      return etatFind ? etatFind.libelle : '';
    },
    getNomPrenomCommercial(commercial) {
      if (!commercial) return '';
      return nomPrenomGetter(commercial);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    async reinitialiser() {
      await this.$refs.filtreListeCommandeTlpe.initializeFiltre();
      this.$refs.filtreListeCommandeTlpe.viderCritere();
      this.$refs.filtreListeCommandeTlpe.appliquerCritere();
      this.showFiltre = false;
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeCommandeTlpe.initializeFiltre();
    },
    makeRechercheFilter(criteresRecherche) {
      this.criteresRecherche = criteresRecherche;
      this.showFiltre = !this.showFiltre;
      this.recherche();
    },
  },
};

</script>
